import AddressCardView from './address-card-view'

export default AddressCardView
